import { useAlone, useIndex } from '@/store';
import pinia from '@/store/store';
import router from '@/router';
const alone = useAlone(pinia)
const index = useIndex(pinia)
/**
 * 请求拦截;
 * beforeRequest 请求前拦截
 * afterRequest  请求后拦截
 */
const interceptor:any = {
    beforeRequest: null,
    afterRequest: null
}

/**
 * 请求前拦截，调用next方法继续下一步请求
 * requestParams接口信息
 * data 请求的参数
 */
interceptor.beforeRequest = ({
    next,
    // requestParams,
    // data
}:any) => {
    // console.log(requestParams, data);
    next()
}
/**
 * 请求后拦截，调用next方法继续返回值
 * result 请求的结果
 * requestId 只是一个请求的标识，没用其他用处，会在afterRequest的返回对象中返回；
 * requestId 主要用来区分请求的来源,可以拼接页面路由上去
 */

//  ,

interceptor.afterRequest = ({
    next,
    result,
    requestInfo
}:any) => {
    if (result.code !== 0) {
        if(result.code === 1001) { // 用户session-id失效
          alone.initUser().then(()=> {
              router.replace("/login");
          })
        }else {
            if(requestInfo.settings && requestInfo.settings.hasOwnProperty.call('errorToast') &&  requestInfo.settings.errorToast ===false){
              //不返回报错信息
              index.setRequestInfo({ result: { error: 0}, requestInfo })
            }else{
              index.setRequestInfo({ result, requestInfo })
            }
        }
    } else if (result.error === 0) {
      index.setRequestInfo({ result: { error: 0 }, requestInfo })
    }
    next()
};
export default interceptor;
